import React, { useState, useEffect } from 'react';
import { useTheme } from '@coreui/react';

// Componente de logo profissional
const CompanyLogo = ({ logo, altText, maxWidth = 150, maxHeight }) => {
  const [theme, setTheme] = useState(
    document.documentElement.getAttribute("data-coreui-theme")
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const newTheme = document.documentElement.getAttribute("data-coreui-theme");
      if (newTheme !== theme) {
        setTheme(newTheme);
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-coreui-theme"],
    });

    return () => observer.disconnect();
  }, [theme]);

  return (
    <div
      className="logo-wrapper"
      style={{
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        backdropFilter: 'blur(20px)', // Efeito de vidro fosco
        backgroundColor: theme === 'dark'
          ? 'rgba(255, 255, 255, 0.5)'  // Fundo translúcido para escuro
          : 'rgba(0, 0, 0, 0.10)',       // Fundo translúcido para claro
        borderRadius: '8px', // Bordas arredondadas suaves
        padding: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' // Sombra para destaque sutil
      }}
    >
      <img
        src={logo}
        alt={altText}
        style={{
          maxWidth,
          maxHeight,
          width: '100%',
          height: 'auto',
          objectFit: 'contain',
        }}
      />
    </div>
  );
};

export default CompanyLogo;